import React, { useState } from "react"
import "./style.scss"
import "../styles/landing-page-styles.css"
import sendAppointment from "./emailSendingScript.js"

import LandingCalendar from "./landigCalendarPicker"

const functionURL = "https://viridian-pony-8522.twil.io/send-sms"

const LandingForm = (props) => {
  if(!props.theme){
    props.theme = "bright";
  }

  var [isChecked, setIsChecked] = useState(0)
  var [buttonIsActive, setbuttonIsActive] = useState(false)
  var [formStatus, setformStatus] = useState("active")
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  const getCurrentDate = () => {
    var currentTime = new Date();
    return currentTime.getMonth()+1 + '/' + currentTime.getDate() + '/' + currentTime.getFullYear();
  }


  const toggleChecked = num => {
    toggleButtonActive()
    if (num === 1) {
      setIsChecked((isChecked = 1))
      toggleButtonActive()
    } else {
      setIsChecked((isChecked = 2))
      toggleButtonActive()
    }
  }

  const toggleButtonActive = () => {
    const phone = document.getElementsByClassName("landingPhoneInput")[0].value
    const phonemo = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/
    if (phone.match(phonemo) && isChecked !== 0) {
      setbuttonIsActive((buttonIsActive = true))
    } else {
      setbuttonIsActive((buttonIsActive = false))
    }
  }

  const handleSubmit = event => {
    event.preventDefault()
  }

  const sendSMS = async event => {
    const smsTime = isChecked === 2 ?  "2PM - 7PM" : "11AM - 2PM";
    const smsPhone = document.getElementsByClassName("landingPhoneInput")[0].value;
    const smsDate = document.getElementsByClassName("hiddenInput")[0].value === "" ? getCurrentDate() : document.getElementsByClassName("hiddenInput")[0].value;
    const smsText = "Your repair is scheduled for " + smsDate + "  between " + smsTime + ". We're looking forward to seeing you. Our address is PhoneFix PRO 2201 Lloyd Center, Portland, OR 97232. Questions call (971) 319-3194";
    const message = { to: smsPhone, body: smsText };

    const { to, body } = message;
    console.log({ to, body })
    const response =  await fetch(functionURL, {
        method: "post",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: new URLSearchParams({ to, body }).toString(),
      })
      if (response.status === 200) {
        console.log("Send!")
      } else {
        console.log('Error');
        const json = await response.json();
        console.log(json);
      }
}

  const handleFormSend = () => {
    const time = isChecked === 2 ? 2 : 1;
    const sentFrom = props.theme === "bright" ? "https://phonefixpro.net/iphone-repairs-landing/": "https://phonefixpro.net/cell-phone-repairs-landing/";

    const phone = document.getElementsByClassName("landingPhoneInput")[0].value;
    const phonemo = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;

    var currentTime = new Date();
    if (document.getElementsByClassName("hiddenInput")[0].value === "") {
      document.getElementsByClassName(
        "day"
      )[0].innerHTML = currentTime.getDate()
      document.getElementsByClassName("month")[0].innerHTML =
        monthNames[currentTime.getMonth()]
      document.getElementsByClassName(
        "year"
      )[0].innerHTML = currentTime.getFullYear();
    }

    if (phone.match(phonemo)) {
      if (window.innerWidth < 1220) {
        window.scrollTo(0, 50);
      }
      setformStatus((formStatus = "loading"))
      setTimeout(function () {
        setformStatus((formStatus = "sended"))
      }, 1500);
      /*if(window['fbq'] && window['fbq'].loaded){
        fbq('track', 'Lead');
      }*/
      if (typeof window !== "undefined") {
        if (window.fbq != null) {
          window.fbq("track", "Lead");
        }
      }
      sendSMS();
      sendAppointment(time, sentFrom);
    } else {
      alert("Incorrect Phone Number");
    }
  }

  return (
    <section className="landingWrapper">
      <div className={props.theme === 'bright' ? "landingFormWrapper landingFormWrapperWide landingFormWrapperBright": "landingFormWrapper landingFormWrapperWide landingFormWrapperDark"}>
        <form
          type="POST"
          onSubmit={handleSubmit}
          autoComplete="off"
          className={formStatus === "active" ? " " : "hiddenItem"}
        >
          <h3 className="landingFormHeader">Pick a Date</h3>
          <div className="landingFormGrid">
            <div className="landingFormCalendarWrapper">
              <LandingCalendar></LandingCalendar>
              <input type="text" className="hiddenInput" />
            </div>

            <div className="landingGridSecondShow landingGridSecond">
              <h3 className="landingTimeHeader">Pick a Time:</h3>

              <div
                className={props.theme === 'bright' ? (
                  isChecked === 1
                    ? "landingCheckedRadioWrapperBright landingRadioWrapper landingRadioWrapperBright"
                    : "landingRadioWrapper landingRadioWrapperBright"
                ):(
                  isChecked === 1
                    ? "landingCheckedRadioWrapperDark landingRadioWrapper landingRadioWrapperDark"
                    : "landingRadioWrapper landingRadioWrapperDark"
                )
                }
                role='radio'
                tabIndex={0}
                onClick={() => toggleChecked(1)} 
                onKeyDown={() => toggleChecked(1)}
                aria-checked='false'
              >
                <input
                  type="radio"
                  className="landingRadio"
                  id='landingRadio1'
                  defaultChecked={isChecked === 1 ? true : false}
                ></input>
                <label className="landingRadioLabel" htmlFor="landingRadio1">11:00 am - 2:00 pm</label>
              </div>

              <div
                className={props.theme === 'bright' ? (
                  isChecked === 2
                    ? "landingCheckedRadioWrapperBright landingRadioWrapper landingRadioWrapperBright"
                    : "landingRadioWrapper landingRadioWrapperBright"
                ):(
                  isChecked === 2
                    ? "landingCheckedRadioWrapperDark landingRadioWrapper landingRadioWrapperDark"
                    : "landingRadioWrapper landingRadioWrapperDark"
                )
                }
                role='radio'
                tabIndex={0}
                onClick={() => toggleChecked(2)} 
                onKeyDown={() => toggleChecked(2)}
                aria-checked='false'
              >
                <input
                  type="radio"
                  className="landingRadio"
                  id='landingRadio2'
                  defaultChecked={isChecked === 2 ? true : false}
                />
                <label className="landingRadioLabel" htmlFor="landingRadio2">2:00 pm - 7:00 pm</label>
              </div>
              <label className="landingPhoneLabel" htmlFor='landingPhoneInputId'>Phone Number:</label>
              <input
                required
                type="tel"
                id='landingPhoneInputId'
                autoComplete="new-password"
                className="landingPhoneInput"
                onChange={toggleButtonActive}
                placeholder="Required"
              />

              <button
                className={props.theme === 'bright' ? (
                  buttonIsActive
                    ? "landingFormSendButton landingFormSendButtonActive landingFormSendButtonActiveBright"
                    : "landingFormSendButton landingFormSendButtonDisabled landingFormSendButtonDisabledBright"
                ) : (
                  buttonIsActive
                    ? "landingFormSendButton landingFormSendButtonActive landingFormSendButtonActiveDark"
                    : "landingFormSendButton landingFormSendButtonDisabled landingFormSendButtonDisabledDark"
                )
                }
                onClick={handleFormSend}
              >
                Schedule
              </button>
            </div>
          </div>
        </form>

        <div
          className={
            formStatus === "loading" ? "landingLoadingWrapper" : "hiddenItem"
          }
        >
          <h3 className="landingLoadingText">
            Scheduling Your Request, Please Wait...
          </h3>
        </div>

        <div
          className={
            formStatus === "sended" ? "landingSendedWrapper" : "hiddenItem"
          }
        >
          <h3 className="landingSendedText">Thanks for Scheduling!</h3>
          <h3>You're all set for your diagnostic</h3>
          <br />
          <h3>
            on <span className="day">Mon</span> <span className="month">D</span>
            , <span className="year">2021</span> between{" "}
            {isChecked === 2 ? "2:00 pm - 7:00 pm" : "11:00 am - 2:00 pm"}.
          </h3>
          <p className="landingSendedTextPar">
            <br />
            PhoneFix PRO
            <br />
            2201 Lloyd Center,
            <br />
            Portland, OR 97232
            <br />
            (971) 319-3194 
            <br />
            <br />
            Thank you, we'll see you soon!
            <br />
          </p>
        </div>
      </div>
    </section>
  )
}

export default LandingForm
